<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div>
      <v-text-field
        v-model.number="node.delay"
        class="mb-3 panzoom-ignore"
        type="number"
        :label="$t('shortcodes.live_chat_mp4.delay_ms')"
        persistent-placeholder
        placeholder="0"></v-text-field>
    </div>
    <div>
      <v-text-field
        class="message-item__settings--delay panzoom-ignore"
        v-model="node.buttonText"
        :label="'Button text'"
        persistent-placeholder
        :placeholder="'Confirm'"></v-text-field>
    </div>
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button background color'"
        :mode="'hex'"
        hide-alpha-slider
        v-model="node.buttonColor"></VaColorPicker>
    </div>
    <div>
      <v-select
        v-model="node.inputQuestionDisplayType"
        :items="inputQuestionTypes"
        :label="$t('shortcodes.live_chat_auto.input_question_display_type')"
        persistent-placeholder
        :placeholder="'Enter age'" />
    </div>
  </div>
</template>

<script>
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import { INPUT_QUESTION_DISPLAY_TYPES } from "./constant";

  export default {
    name: "LiveChatMp4InputQuestion",
    components: { VaColorPicker },

    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        inputQuestionTypes: INPUT_QUESTION_DISPLAY_TYPES,
      };
    },
  };
</script>
